import React, { useRef, useEffect, useState } from 'react';
import { Outlet } from 'react-router';

import { EventEditorProvider } from './EventEditorProvider';
import { EditorEventStateBanner } from './components/EventEditorBanner';
import { EventEditorHeader } from './components/EventEditorHeader';
import { EditEventDetailsSheet } from './components/EditEventDetailsSheet';
import { DeleteDraftEventModal } from './components/DeleteDraftEventModal';
import { CancelEventModal } from './components/CancelEventModal';
import { SchedulePublishModal } from './components/SchedulePublishModal';
import { PublishErrorsModal } from './components/PublishErrorsModal';
import { InviteGuestsModal } from './components/InviteGuestsModal';
import { EditEventSelfCheckinModal } from './components/EditEventSelfCheckinModal';
import { EditFeedbackSettingsModal } from './components/EditFeedbackSettingsModal';
import { ResendFeedbackFormModal } from './tabs/EditEventFeedback/components/ResendFeedbackFormModal';
import { AsyncInviteJobProcessingToast } from './components/AsyncInviteJobProcessingToast';
import { CreateDraftSessionSheet } from './components/CreateDraftSessionSheet';

export const EventEditorLayout = (): React.ReactElement => {
  const bannerRef = useRef<HTMLDivElement>(null);
  const [bannerHeight, setBannerHeight] = useState<number>(0);

  useEffect(() => {
    const bannerElement = bannerRef.current;
    if (!bannerElement) return undefined;

    const handleResize = (): void => setBannerHeight(bannerElement.clientHeight ?? 0);

    const observer = new ResizeObserver(handleResize);
    observer.observe(bannerElement);

    // Call once to set initial value
    handleResize();

    return (): void => {
      observer.disconnect();
    };
  }, []);

  return (
    <EventEditorProvider>
      <EditorEventStateBanner ref={bannerRef} />

      <EventEditorHeader style={{ top: `${bannerHeight}px` }} />

      <div className="tw-mx-auto tw-mt-8 tw-w-full tw-p-4 !tw-pb-16 md:tw-w-[900px] md:tw-p-0">
        <Outlet />
      </div>

      {/* Global modals and sheets */}
      <CancelEventModal />
      <EditEventDetailsSheet />
      <DeleteDraftEventModal />
      <SchedulePublishModal />
      <PublishErrorsModal />
      <InviteGuestsModal />
      <EditEventSelfCheckinModal />
      <EditFeedbackSettingsModal />
      <ResendFeedbackFormModal />
      <CreateDraftSessionSheet />

      <AsyncInviteJobProcessingToast />
    </EventEditorProvider>
  );
};
